import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { getCitation } from './get.citations';
import { NumberedCitation } from '../../models';

export const getSelectedNumberedCitation = createSelector(
  [getCitation],
  ({ references, selectedNumberedCitationId }): NumberedCitation | undefined =>
    selectedNumberedCitationId &&
    find(references, (e) => e.referencedBy[0] === selectedNumberedCitationId)
);
